import { EvergreenPage } from '../components/seo/EvergreenPage'
import { EMAIL_UPTIME_ALERTS_SECTIONS } from '../content/seo/emailUptimeAlerts'
import { articleJsonLd } from '../seo/structuredData'
import { PAGE_META } from '../seo/pageMeta'

const meta = PAGE_META['/email-uptime-alerts']

export function EmailUptimeAlertsPage() {
  return (
    <EvergreenPage
      path="/email-uptime-alerts"
      title="Email uptime alerts for your team"
      lead="Send downtime and expiry alerts to email recipients on your escalation policies—alongside Slack alerts on every Pingscalate plan."
      sections={EMAIL_UPTIME_ALERTS_SECTIONS}
      jsonLd={articleJsonLd({
        title: meta.title,
        description: meta.description,
        path: '/email-uptime-alerts',
      })}
    />
  )
}
